import React, { Component } from "react";
import ScreenCardHolder from "./Styles/screenCardStyle";
import { Button, Icon, Tooltip, Modal, Row, Col, Divider, Badge} from "antd";
import Slider from "react-slick";
import Dotdotdot from "react-dotdotdot";
import { withTranslation } from "react-i18next";
import NumberFormat from "./NumberFormat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";
import UserRoleEnum from "../constants/UserRoleEnum";
import { hasAccessRole } from "../services/utils";
import { isRemoveDisabledInApproved } from "../services/campaignManager";
import ScreenContainer from "../newSrc/shared/containers/ScreenContainer";
import { Provider } from "react-redux";
import { store } from "../redux";
import AudienceSummaryComponentGeneral from "./AudienceSummaryComponentGeneral";
import defaultImage from "../images/bg.jpg";
import { BundleSvg } from "../images/customIcons/BundleSvg";
import TagsDiscount from "./TagsDiscount"
import { getLocationType, belongsToBundle, checkIfBundle, displayIsCircuit, circuitHasMultipleFaces, displayIsMultipleFaces, getMultipleFacesCountInCircuit, getTotalMultipleFacesInCircuit } from "../services/display";
import RequestSpecialCpmContainer from "../containers/RequestSpecialCpmContainer";
import RequestSpecialPriceContainer from "../containers/RequestSpecialPriceContainer";
import DeleteBundleModalComponent from "./DeleteBundleModalComponent";
import { faHandshake } from '@fortawesome/free-solid-svg-icons';
import VerifiedAgencyInfoModal from "./VerifiedAgencyInfoModal";
import CircuitButton from "./customComponents/CircuitButton/CircuitButton";
import MultipleFacesButton from "./customComponents/MultipleFacesButton/MultipleFacesButton";
import Colors from "../themes/Colors";
import { getVenueIcon, getVenueSubtypeLabel } from "../services/venueCategories";
import SyncCircuitAlert from "./shared/SyncCircuit/SyncCircuitAlert";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: "8%", top: "35%" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        left: "8%",
        top: "35%",
        zIndex: "1",
      }}
      onClick={onClick}
    />
  );
}

class ScreenCardComponent extends Component {
  getSizeType(type) {
    if (type === "small") {
      return this.props.t("Small");
    }
    if (type === "medium") {
      return this.props.t("Medium");
    }
    if (type === "big") {
      return this.props.t("Big");
    }
    if (type === "giant") {
      return this.props.t("Giant");
    }
  }

  state = {
    visibleAudienceView: false,
    visibleWarningNoAutomateView: false,
    showScreenDetail: false,
    displaysAudience: [],
    isVerifiedAgencyModalVisible: false,
    deleteModalVisible: false,
    isCircuit: false,
  };

  componentDidMount() {
    this.setState({
      isCircuit: this.props.display.secondary_displays && this.props.display.secondary_displays.length > 0,
    });
  }

  handleDeleteModal = () => {
    this.setState({
      deleteModalVisible: !this.state.deleteModalVisible,
    });
  };
  showAudienceModal = () => {
    if (this.props.user) {
      this.setState({ visibleAudienceView: true });
    } else {
      this.props.setShouldPromptLogin(true, "");
    }
  };

  okAudienceModal = (e) => {
    this.setState({ visibleAudienceView: false });
  };

  cancelAudienceModal = (e) => {
    this.setState({ visibleAudienceView: false });
  };

  showWarningNoAutomateModal = () => {
    this.setState({ visibleWarningNoAutomateView: true });
  };

  okWarningNoAutomateModal = (e) => {
    this.setState({ visibleWarningNoAutomateView: false });
  };

  cancelWarningNoAutomateModal = (e) => {
    this.setState({ visibleWarningNoAutomateView: false });
  };

  handleShowScreenDetail = (defaultTabScreenDetail) => {
    this.setState((prevState) => ({
      showScreenDetail: !prevState.showScreenDetail,
    }))
    if (defaultTabScreenDetail != "close"){
      this.setState(() => ({
        defaultTabScreenDetail: defaultTabScreenDetail,
      }));
    }
  };

  showVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: true });
  };

  hideVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: false });
  };

  screenOwnerProviderId = 2;
  getAudienceProviderName = (provider) => {
    return provider && provider.stylized_name && provider.id !== this.screenOwnerProviderId ? provider.stylized_name : this.props.t('display owner');
  };

  render() {
    const { t, user, display, editCampaignActive, currentCampaign, cart , listBundle, removeBundlesFromCart, getAudienceHoursOfDayRequest, getAudienceDaysOfWeekRequest, getAudienceQualitativeRequest} = this.props;
    const subtypeLabel = getVenueSubtypeLabel(display, t);
    const { showScreenDetail , defaultTabScreenDetail, deleteModalVisible} = this.state;
    const isAgencyUser = user && user.company && user.company.type == "agency";
    const isVerifiedAgency =  isAgencyUser && user.company.is_verified;

    var matchBundle = belongsToBundle(display, listBundle);

    let countBundlesAdded = checkIfBundle (display.bundles, listBundle)

    let onCart = this.props.cart.find((d) => d.id === this.props.display.id);
    const disableRemove = isRemoveDisabledInApproved({
      paymentStatus: this.props.editCampaign.payment_status,
      editCampaignActive: this.props.editCampaignActive,
      onCart,
      displayId: display.id,
      initialBackup: this.props.initialBackup,
      hasInitialBackup: this.props.hasInitialBackup,
    });

    // Modal width
    const modalWidth = window.innerWidth > 1200 ? 1200 : window.innerWidth > 992 ? 900 : window.innerWidth;

    var settings = {
      arrows: true,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToScroll: 1,
      slidesToShow: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };

    return (
      <ScreenCardHolder>
        <div className="screenCard">
          <Row type="flex">
            <Col span={12}>
              <Slider {...settings}>
                {display.pictures.length === 0 ? (
                  <img
                    src={defaultImage}
                    alt=""
                    className="screenCardImage"
                  />
                ) : (
                  this.props.display.pictures &&
                  this.props.display.pictures.map((p, index) => (
                    <img
                      key="{index}"
                      src={
                        p.url
                          .split(".")
                          .slice(0, -1)
                          .join(".") + "-thumb.jpg"
                      }
                      alt=""
                      className="screenCardImage"
                    />
                  ))
                )}
              </Slider>
            </Col>
            <Col span={12}>
              <div className="screenCardContent">

                <div className="cardTitle" style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip
                    placement="top"
                    title={
                      user &&
                        hasAccessRole(user.roles, [
                          UserRoleEnum.superModeratorAgency,
                          UserRoleEnum.superModeratorMediaCompany,
                        ])
                        ? " (" +
                        this.props.display.name + ' - ' +
                        this.props.display.id +
                        ")"
                        : " (" + this.props.display.name + ")"
                    }
                  >
                    <span>
                      <Dotdotdot clamp={1}>{this.props.display.name}</Dotdotdot>
                    </span>
                  </Tooltip>
                  {(this.props.display.audience_provider_id == 1 || this.props.display.third_party_average_monthly_audience) &&
                    <Tooltip
                      placement="top"
                      title={t("Audience data for this screen provided by") + " " + this.getAudienceProviderName(this.props.display.audience_provider)}
                    >
                      <Icon
                        style={{ color: Colors.atention, paddingLeft: "5px", fontSize: "large" }}
                        type="star" >
                      </Icon>
                    </Tooltip>
                  }
                </div>

                <div className="screenCardPrice">
                  <Tooltip placement="top" title={t("Final prices may contain platform commissions and may vary depending on the selected client")} >
                    <NumberFormat
                      value={
                        this.props.programmatic === "programmatic"
                          ? this.props.display.cpmi
                          : this.props.display.price_per_day
                      }
                      currency={this.props.display.price_currency}
                      include_currency={true}
                    />
                    {this.props.programmatic === "programmatic"
                      ?
                      <span>
                        {t("CPM")}
                      </span>
                      : <> {" / " + t("Day")}
                        {(this.props.display.rank_discount_apply && this.props.display.rank_discount_apply.discount) ?
                          <Tooltip placement="right"
                            title={
                              <span>
                                {t('Discount applied') + ' ' + this.props.display.rank_discount_apply.discount}%
                              </span>
                            }>
                            <Icon
                              style={{ color: Colors.atention, paddingLeft: "10px", fontSize: "large" }}
                              type="tags" theme="outlined">
                            </Icon>
                          </Tooltip> : null
                        }
                      </>
                    }
                  </Tooltip>
                  {/* Request special CPM */}
                  {isAgencyUser && isVerifiedAgency && this.props.programmatic === "programmatic" ?
                    <RequestSpecialCpmContainer displayId={this.props.display.id} originalBaseCpm={this.props.display.base_cpmi} agreedBaseCpm={this.props.display.arranged_cpmi}></RequestSpecialCpmContainer>
                    : null
                  }
                  {/* Request special traditional price */}
                  {isAgencyUser && isVerifiedAgency && this.props.programmatic !== "programmatic" ?
                    <RequestSpecialPriceContainer displayId={this.props.display.id} originalBasePrice={(this.props.display.original_base_price_per_day)} agreedBasePrice={(this.props.display.arranged_price_per_day)}></RequestSpecialPriceContainer>
                    : null
                  }
                  {/* If agency is not verified, show help information */}
                  {isAgencyUser && !isVerifiedAgency ?
                    <Tooltip placement="top" title={t("Request agreed price")} >
                      <Button type="dashed" shape="circle" onClick={this.showVerifiedAgencyModal} size="small" style={{ marginLeft: "5px" }}>
                        <FontAwesomeIcon icon={faHandshake} size="20px" style={{ color: "grey" }} className='icoinversenEdit' />
                      </Button>
                    </Tooltip>
                    : null
                  }
                </div>
                <Divider style={{ margin: "5px" }} />
                <div className="cardInfo">
                  <Dotdotdot clamp={1}>
                    {t("Resolution")} {this.props.display.resolution_width}
                    {"x"}
                    {this.props.display.resolution_height}
                  </Dotdotdot>
                </div>
                <Row type="flex">
                  <Col span={24}>
                    <span
                      style={{ textTransform: "capitalize" }}
                      className="cardInfo"
                    >
                      {t("Size")}{" "}
                      {this.getSizeType(this.props.display.size_type)}
                    </span>
                  </Col>
                  <Col span={24}>
                    <span
                      style={{ textTransform: "capitalize", fontSize: "10px" }}
                      className="cardInfo"
                    >
                      {t("Slot duration")}{" "}
                      {this.props.display.slot_length / 1000} {t("secs")}
                    </span>
                  </Col>
                  {display.company && display.company.name && (
                    <Col span={24}>
                      <span
                        style={{ fontSize: "10px" }}
                        className="cardInfo"
                      >
                        {this.props.display.company.name}{" "}  
                        {/* Only render compnay id for supers */}
                        {user && (hasAccessRole(user.roles, [UserRoleEnum.superAdmin, UserRoleEnum.superModeratorAgency, UserRoleEnum.superModeratorMediaCompany])) && (
                          <span>
                            ({this.props.display.company.id})
                          </span>
                        )}
                      </span>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="rowButton">
              <Row type="flex">
                <Col xs={9} sm={9} md={9} lg={24} xl={8} className="colButtonFirst">
                  {!display.location_type ||
                    <span style={{ display: "inline-flex", alignItems: "center" }}>
                      <FontAwesomeIcon icon={getVenueIcon(display)} style={{ color: Colors.coal, fontSize: 22 }} />
                      <span className="iconTypeScreen" style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                        {`
                          ${this.state.isCircuit ? t("circuit") : ""}
                          ${getLocationType(display.location_type, t) || display.location_type}
                          ${subtypeLabel ? `- ${subtypeLabel}` : ""}`
                        }
                        {display.sync_circuit &&
                          <SyncCircuitAlert/>
                        }
                      </span>
                    </span>
                  }
                </Col>
                <Col xs={14} sm={14} md={14} lg={24} xl={14} style={{textAlign:"end", alignItems: "baseline"}}>
                  {this.props.display.display_type === "main" &&
                    this.state.isCircuit ? (
                      <CircuitButton secondaryDisplays={this.props.display.secondary_displays} />
                  ) : null}
                  {displayIsMultipleFaces(this.props.display) &&
                    <MultipleFacesButton mirror_screens_count={this.props.display.mirror_screens_count} />
                  }
                  {(((display.rank_discounts && display.rank_discounts.length > 0)
                    && this.props.programmatic === 'traditional')) &&
                    <div
                      className="borderTagDiscount"
                    >
                      <TagsDiscount
                        display={this.props.display}
                        currency={this.props.display.price_currency}
                      />
                    </div>
                  }
                  <Tooltip placement="bottomLeft" title={t("Audience detail")}>
                    <Button
                      className="screenCardAudit"
                      shape="circle"
                      size="small"
                      onClick={() => this.showAudienceModal()}
                    >
                      <Icon type="audit" theme="outlined" />
                    </Button>
                  </Tooltip>
                  <Modal // AUDIENCE MODAL
                    title={t("Audience")}
                    visible={this.state.visibleAudienceView}
                    onOk={this.okAudienceModal}
                    onCancel={this.cancelAudienceModal}
                    width={1000}
                  >
                    <AudienceSummaryComponentGeneral
                      t={t}
                      display={display}
                      user={user}
                      campaign={ editCampaignActive ? currentCampaign : null}
                      audienceHoursOfDay = { this.props.audienceHoursOfDay }
                      audienceDaysOfWeek = { this.props.audienceDaysOfWeek }
                      audienceQualitative = { this.props.audienceQualitative }
                      getAudienceHoursOfDayRequest={getAudienceHoursOfDayRequest}
                      getAudienceDaysOfWeekRequest={getAudienceDaysOfWeekRequest}
                      getAudienceQualitativeRequest={getAudienceQualitativeRequest}
                    />
                  </Modal>
                  {displayIsMultipleFaces(this.props.display) ? (
                    <Tooltip
                      placement="bottomLeft"
                      title={`${t("Multiple faces screen")} (${this.props.display.mirror_screens_count})`}
                    >
                      <Button
                        className="doubleScreen"
                        shape="circle"
                        size="small"
                        style={{marginLeft: "7px"}}
                      >
                        <FontAwesomeIcon
                          icon={faClone}
                          size="20x"
                          className="iconTranslate"
                        />
                      </Button>
                    </Tooltip>
                  ) : displayIsCircuit(this.props.display) && circuitHasMultipleFaces(this.props.display.secondary_displays) ? (
                    <Tooltip
                      placement="bottomLeft"
                      title={
                        <>
                          {t("Multiple faces screen")}:
                          <br />
                          {getMultipleFacesCountInCircuit(this.props.display.secondary_displays)} {t("screens_abbreviated")} / {getTotalMultipleFacesInCircuit(this.props.display.secondary_displays)} {t("faces")}
                        </>
                      }
                    >
                      <Button
                        className="doubleScreen"
                        shape="circle"
                        size="small"
                        style={{marginLeft: "7px"}}
                      >
                        <FontAwesomeIcon
                          icon={faClone}
                          size="20x"
                          className="iconTranslate"
                        />
                      </Button>
                    </Tooltip>
                  ) : null}
                  <span>
                    <Tooltip placement="top" title={t("Screen detail")}>
                      <Button
                        className="screenCardInformation"
                        shape="circle"
                        size="small"
                        onClick={() => this.handleShowScreenDetail("info")}
                      >
                        <Icon type="info-circle" theme="outlined" />
                      </Button>
                    </Tooltip>
                  </span>
                  { display.bundles && display.bundles.length > 0 ?
                    <Tooltip placement="top" title={t("Sales bundle details")}>
                      <Button
                        style={{marginLeft: "7px", marginRight: "2px", top: "9px",}}
                        shape="circle"
                        onClick={() => this.handleShowScreenDetail("bundles")}
                      >
                      <Badge count={
                        <>
                          {display.bundles.length > 0 && (
                            countBundlesAdded !== 0 && countBundlesAdded < display.bundles.length ? (
                              <>
                                <Icon type="plus-circle" className="addIconBundle" theme="filled"/>
                                <Icon type="minus-circle" className="minusIconBundle" theme="filled"/>
                              </>
                            ) : (
                              countBundlesAdded === display.bundles.length ?
                                <Icon type="minus-circle" className="minusIconBundle" theme="filled"/>:
                                <Icon type="plus-circle" className="addIconBundle" theme="filled"/>
                            )
                          )}
                        </>
                      }>
                        <Icon component={BundleSvg} style={{width: '30px'}}/>
                      </Badge>
                      </Button>
                    </Tooltip>
                  :null}
                  <Modal
                    title={t("Screen detail")}
                    visible={showScreenDetail}
                    onCancel={() =>this.handleShowScreenDetail("close")}
                    footer={[
                      <Button key="back" onClick={() =>this.handleShowScreenDetail("close")}>
                        OK
                      </Button>,
                    ]}
                    width={modalWidth}
                    style={{ top: "10px" }}
                  >
                    <Provider store={store}>
                      <ScreenContainer
                        display={display}
                        screenDetail={showScreenDetail}
                        popup={true}
                        // Tab for bundles
                        defaultTab={defaultTabScreenDetail}
                        editCart={true}
                        closeModal={() => this.handleShowScreenDetail("close")}
                      />
                    </Provider>
                  </Modal>
                  <DeleteBundleModalComponent
                    deleteModalVisible={deleteModalVisible}
                    matchBundle={matchBundle}
                    handleDeleteModal={this.handleDeleteModal}
                    cart={cart}
                    listBundle={listBundle}
                    removeBundlesFromCart={removeBundlesFromCart}
                  />
                  { !display.bundle_only ?
                    <Tooltip
                      placement="top"
                      title={disableRemove ? t("To remove this screen, advance to the next step and transfer its outputs to another screen.") : null}
                    >
                      <Button
                        disabled={disableRemove || false}
                        className={
                          onCart ? "screenCardRemoveButton" : "screenCardAddButton"
                        }
                        shape="circle"
                        icon={onCart ? "minus" : "plus"}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onCart) {
                            if (matchBundle){
                              this.handleDeleteModal()
                            } else {
                              this.props.removeDisplayFromCart(this.props.display.id);
                            }
                          } else {
                            this.props.addDisplayToCart(this.props.display);
                          }
                          onCart = !onCart;
                        }}
                      />
                    </Tooltip>
                  :null}
                </Col>
              </Row>
            </Col>
            <Modal //NON-AUTOMATED MODAL
              title={t("Non-automated screen")}
              visible={this.state.visibleWarningNoAutomateView}
              onOk={this.okWarningNoAutomateModal}
              onCancel={this.cancelWarningNoAutomateModal}
            >
              <p style={{ margin: "25px" }}>
                {t(
                  "This screen does not have the real-time print notice. Therefore, print reports may take up to 48 hours to be reflected."
                )}
              </p>
            </Modal>
            <VerifiedAgencyInfoModal isVisible={this.state.isVerifiedAgencyModalVisible} hide={this.hideVerifiedAgencyModal}></VerifiedAgencyInfoModal>
          </Row>
        </div>
      </ScreenCardHolder>
    );
  }
}
export default withTranslation()(ScreenCardComponent);
